import styled, { css } from 'styled-components';
import background from '@/media/onboarding/sitebuilder-v2/bg-gradient.svg';

export const Wrapper = styled.div`
  ${({ theme }) => css`
    background: ${theme.v2.colors.white.primary};
    font-family: ${theme.v2.font.family.primary};
    width: 100%;
  `}
`;

export const ButtonBackWrapper = styled.div`
  align-items: center;
  display: flex;
  height: 80px;
  left: 26px;
  top: 0;
  position: absolute;
  z-index: 10;
`;

export const WaveTop = styled.div`
  ${({ theme }) => css`
    background: url(${background}) no-repeat center top;
    background-size: 100% 300px;
    height: 300px;
    overflow: hidden;
    position: absolute;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      background-size: 100% 180px;
      height: 180px;
    }
  `};
`;

export const CirclesImage = styled.img`
  ${({ theme }) => css`
    height: 320px;
    right: 5vw;
    position: absolute;
    top: -213px;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      top: -60px;
      right: -60px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 144px;
      right: -80px;
    }
  `}
`;

export const StarImage = styled.img`
  ${({ theme }) => css`
    height: 400px;
    top: -256px;
    position: absolute;
    left: -3vw;
    user-select: none;
    z-index: 1;
    -webkit-user-drag: none;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      height: 200px;
      left: -40px;
      top: 40px;
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      height: 144px;
    }
  `};
`;

export const InnerContainer = styled.div`
  ${({ theme }) => css`
    align-items: center;
    display: flex;
    flex-direction: column;
    height: 100%;
    position: relative;
    z-index: 2;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
    }
  `};
`;

export const TopBannerTitle = styled.h3`
  ${({ theme }) => css`
    color: ${theme.v2.colors.white.primary};
    font-size: ${theme.v2.font.sizes.md};
    font-weight: ${theme.v2.font.weights.medium};
    margin: 60px 0;
    text-align: center;

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      font-size: ${theme.v2.font.sizes.xs};
      margin: 28px 80px;
    }
  `}
`;

export const ChipsWrapper = styled.div`
  ${({ theme }) => css`
    align-items: center;
    box-sizing: border-box;
    display: flex;
    gap: 16px;
    justify-content: space-between;
    margin: 90px auto 56px;
    max-width: 1360px;
    padding: 16px;
    width: 100%;

    & label {
      & svg {
        display: none;
      }
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      margin: 40px 16px 20px;
    }
  `}
`;

export const ChipsControls = styled.button`
  ${({ theme, $disabled }) => css`
    align-items: center;
    appearance: none;
    background-color: ${theme.v2.colors.white.primary};
    border: 1px solid ${$disabled ? theme.v2.colors.neutral.lowLight : theme.v2.colors.neutral.highMedium};
    border-radius: 50%;
    box-sizing: border-box;
    cursor: ${$disabled ? 'not-allowed' : 'pointer'};
    display: flex;
    height: 37px;
    justify-content: center;
    opacity: ${$disabled ? 0.5 : 1};
    transition: all 0.2s ease;
    width: 37px;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      display: none;
    }
  `}
`;

export const ChipsScroll = styled.div`
  ${({ theme }) => css`
    flex: 1;
    overflow-x: auto;
    overflow-y: hidden;
    padding: 8px 0;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    @media (max-width: ${theme.v2.breakpoints.md}) {}
  `}
`;

export const ChipsInner = styled.div`
  ${({ theme }) => css`
    display: flex;
    gap: 16px;

    @media (max-width: ${theme.v2.breakpoints.md}) {}
  `}
`;

export const ChipContainer = styled.div`
  ${({ theme, $checked }) => css`
    padding: 1px;
    white-space: nowrap;

    label {
      font-weight: ${$checked ? theme.v2.font.weights.medium : theme.v2.font.weights.regular};
    }
  `}
`;

export const TemplatesListWrapper = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;
`;

export const TemplatesList = styled.ul`
  ${({ theme }) => css`
    display: grid;
    gap: 24px;
    grid-template-columns: repeat(4, 1fr);
    margin: 0;
    max-width: 1360px;
    padding: 0 24px;
    row-gap: 56px;
    width: 100%;

    @media (max-width: ${theme.v2.breakpoints.md}) {
      grid-template-columns: repeat(3, 1fr);
    }

    @media (max-width: ${theme.v2.breakpoints.sm}) {
      grid-template-columns: repeat(2, 1fr);
      gap: 16px;
      row-gap: 32px;
    }
  `};
`;

export const PaginationWrapper = styled.div`
  display: flex;
  justify-content: center;
  margin: 40px 0 80px;
  width: 100%;
`;
